// FNP-1193 — labels and paths every navigate/link in the module references, so
// a route rename is one edit rather than a grep.
//
// ⚠️ A CERTIFICATE HAS A TOP-LEVEL INDEX, unlike a DNS record.
//
// A record has no identity outside its zone, so its only address is nested
// under one. A certificate is a tenant-owned asset in its own right — it is
// listed by tenant, not by zone, and `listCertificates` takes no zone argument
// at all. So the route FNP-1186 registered is a plain `/certificates`.
export default {
    entityKey: 'certificates',
    basePath: '/certificates',
    // The zone a validation record was written into, so an operator reading a
    // STUCK certificate can go and look at the zone that should hold it.
    //
    // ⚠️ `connectionId` RIDES ALONG, because `getDnsZone(connectionId: ID!,
    // id: ID!)` needs both and a zone id alone cannot address a zone.
    zonePath: (zoneId: string, connectionId?: string): string => {
        const base = `/zones/${encodeURIComponent(zoneId)}`;
        return connectionId
            ? `${base}?connectionId=${encodeURIComponent(connectionId)}`
            : base;
    },
    // The records inside that zone — where the validation record itself lives.
    zoneRecordsPath: (zoneId: string, connectionId?: string): string => {
        const base = `/zones/${encodeURIComponent(zoneId)}/records`;
        return connectionId
            ? `${base}?connectionId=${encodeURIComponent(connectionId)}`
            : base;
    },
    titles: {
        singular: 'Certificate',
        plural: 'Certificates',
    },
};
